import type { AppRole } from "../types";
import type { PayableStatus } from "./invoicingTypes";

/**
 * Almikia Epic E6 (TASK-041): pure rules of the "Cuentas por pagar" screens.
 */

/** Statuses offered as filter chips (a cancelled row stays reachable by search only). */
export const PAYABLE_FILTER_STATUSES = [
  "pendiente_vobo",
  "por_pagar",
  "pagada",
] as const satisfies readonly PayableStatus[];

/** An asesora / lider only ever sees the rows she is paid ("Mis pagos"). */
export const isOwnPayablesRole = (role: AppRole): boolean =>
  role === "asesora" || role === "lider";

/**
 * QE6-A2: only roles that can be a payee are told that the payment depends on
 * uploading her own invoice. UX only; the SQL generation rule is untouched.
 */
export const canSeeAdvisorInvoiceNotice = (role: AppRole): boolean =>
  isOwnPayablesRole(role);

/** Local calendar date as `YYYY-MM-DD` (the default of the payment date). */
export const todayIsoDate = (now: Date = new Date()): string =>
  `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(
    now.getDate(),
  ).padStart(2, "0")}`;
